import { signOut } from 'aws-amplify/auth';

// Single source of truth for an INVOLUNTARY sign-out (session expired via a
// 401, or hit the inactivity timeout). Mirrors the manual user-menu.logOut():
// clear org state, drop Amplify's Cognito tokens, then hard-redirect to the
// sign-in surface. The full reload also clears any in-memory Duende/OAuth
// state, which matters for grandfathered identities. `reason` is surfaced as
// a query flag the sign-in page can read to show an explanatory message.
export async function forceSignOutRedirect(
  reason: 'expired' | 'idle',
): Promise<void> {
  sessionStorage.clear();
  try {
    await signOut();
  } catch {
    /* ignore -- redirect regardless so a dead/idle session can't trap the user */
  }
  window.location.href =
    window.location.origin + `/#/auth/sign-in?reason=${reason}`;
}
